var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSupplierChatbotDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.625,
    fill: "white",
    stroke: "#E5E5E7",
    strokeWidth: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20C20.9946 20 21.9484 19.6049 22.6517 18.9016C23.3549 18.1984 23.75 17.2446 23.75 16.25C23.75 15.2554 23.3549 14.3016 22.6517 13.5983C21.9484 12.8951 20.9946 12.5 20 12.5C19.0054 12.5 18.0516 12.8951 17.3483 13.5983C16.6451 14.3016 16.25 15.2554 16.25 16.25C16.25 17.2446 16.6451 18.1984 17.3483 18.9016C18.0516 19.6049 19.0054 20 20 20ZM22.5 16.25C22.5 16.913 22.2366 17.5489 21.7678 18.0178C21.2989 18.4866 20.663 18.75 20 18.75C19.337 18.75 18.7011 18.4866 18.2322 18.0178C17.7634 17.5489 17.5 16.913 17.5 16.25C17.5 15.587 17.7634 14.9511 18.2322 14.4822C18.7011 14.0134 19.337 13.75 20 13.75C20.663 13.75 21.2989 14.0134 21.7678 14.4822C22.2366 14.9511 22.5 15.587 22.5 16.25ZM27.5 26.25C27.5 27.5 26.25 27.5 26.25 27.5H13.75C13.75 27.5 12.5 27.5 12.5 26.25C12.5 25 13.75 21.25 20 21.25C26.25 21.25 27.5 25 27.5 26.25ZM26.25 26.245C26.2488 25.9375 26.0575 25.0125 25.21 24.165C24.395 23.35 22.8612 22.5 20 22.5C17.1375 22.5 15.605 23.35 14.79 24.165C13.9425 25.0125 13.7525 25.9375 13.75 26.245H26.25Z",
    fill: "#3D3D43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSupplierChatbotDefault);
export default __webpack_public_path__ + "static/media/icon-supplier-chatbot-default.98b9296db22a2caf9a1bd78014f4eeb6.svg";
export { ForwardRef as ReactComponent };